"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var eligibility_1 = require("@bhtp-client-api/eligibility");
var ng2_bs3_modal_1 = require("@bhtp-fork/ng2-bs3-modal/ng2-bs3-modal");
var error_message_display_1 = require("./../error-message-display");
var acknowledgements_1 = require("./acknowledgements");
var modals_1 = require("./modals");
exports.DECLARED_AND_EXPORTED_COMPONENTS = [
    acknowledgements_1.AcknowledgementsComponent,
    acknowledgements_1.AcknowledgementSelectorComponent,
    modals_1.ApiMessageModalComponent,
    modals_1.CustomersModalComponent,
    modals_1.LoadingModalComponent,
    modals_1.MessageModalComponent
];
var BhtpMiscModule = (function () {
    function BhtpMiscModule() {
    }
    return BhtpMiscModule;
}());
BhtpMiscModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule,
            ng2_bs3_modal_1.Ng2Bs3ModalModule,
            error_message_display_1.BhtpErrorMessageDisplayModule,
            eligibility_1.BhtpEligibilityModule
        ],
        declarations: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS
        ],
        exports: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS
        ],
        providers: [
            modals_1.ModalService
        ]
    })
], BhtpMiscModule);
exports.BhtpMiscModule = BhtpMiscModule;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/misc.module.js